const root = process.env.H5_API_ROOT;
export default root.split('/v')[0];


// WEBPACK FOOTER //
// ./src/app/script/apiFile.js